import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'document-pill',
    templateUrl: './document-pill.component.html',
    styleUrls: ['./document-pill.component.scss']
})
export class DocumentPillComponent implements OnInit {
    @Input() filename: string;
    @Input() bytes: number;
    icon: string;

    constructor() { }

    ngOnInit() {
        this.icon = this.getIcon();
    }

    private getIcon(): string {
        const ext = this.getFileExtension(this.filename);
        if (!ext) {
            return 'file';
        }
        const icons = [
            {name: 'file', test: x => !x},
            {name: 'pdf', test: x => x === 'pdf'},
            {name: 'word', test: x => ['doc', 'docx'].includes(x)},
            {name: 'excel', test: x => x.startsWith('xl')},
            {name: 'img', test: x => ['jpg', 'jpeg', 'png', 'gif', 'tiff', 'bmp'].includes(x)}
        ];
        const icon = _.find(icons, x => x.test(ext)) as any;
        return icon ? icon.name : 'file';
    }

    private getFileExtension(filename): string|null {
        const ext = /^.+\.([^.]+)$/.exec(filename);
        return !ext ? null : ext[1];
    }
}
